
// @ts-nocheck


export const localeCodes =  [
  "tr",
  "en"
]

export const localeLoaders = {
  "tr": [{ key: "../locales/tr.json", load: () => import("../locales/tr.json" /* webpackChunkName: "locale_C_58_C_58_Duhan_32Projects_teknopark_site_locales_tr_json" */), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale_C_58_C_58_Duhan_32Projects_teknopark_site_locales_en_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "tr",
      "name": "Türkçe",
      "files": [
        "C:/Duhan Projects/teknopark-site/locales/tr.json"
      ]
    },
    {
      "code": "en",
      "name": "English",
      "files": [
        "C:/Duhan Projects/teknopark-site/locales/en.json"
      ]
    }
  ],
  "defaultLocale": "tr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "http://localhost:3000",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "news/index": {
      "en": "/news",
      "tr": "/haberler"
    },
    "news/[slug]": {
      "en": "/news/[slug]",
      "tr": "/haberler/[slug]"
    },
    "about/partners": {
      "en": "/about/partners",
      "tr": "/hakkimizda/ortaklar"
    },
    "events/index": {
      "en": "/events",
      "tr": "/etkinlikler"
    },
    "events/[slug]": {
      "en": "/events/[slug]",
      "tr": "/etkinlikler/[slug]"
    },
    "services/conference-room": {
      "en": "/services/conference-room",
      "tr": "/hizmetler/konferans-salonu"
    },
    "services/rental-fees": {
      "en": "/services/rental-fees",
      "tr": "/hizmetler/kira-ucretleri"
    },
    "companies-all": {
      "en": "/companies/all",
      "tr": "/firmalar/tumu"
    },
    "companies/[slug]": {
      "en": "/companies/[slug]",
      "tr": "/firmalar/[slug]"
    },
    "companies/sectors": {
      "en": "/companies/sectors",
      "tr": "/firmalar/sektorler"
    },
    "companies/sectors/[slug]": {
      "en": "/companies/sectors/[slug]",
      "tr": "/firmalar/sektorler/[slug]"
    },
    "pages/[...slug]": {
      "en": "/page/[...slug]",
      "tr": "/sayfa/[...slug]"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "tr",
    "name": "Türkçe",
    "files": [
      {
        "path": "C:/Duhan Projects/teknopark-site/locales/tr.json"
      }
    ]
  },
  {
    "code": "en",
    "name": "English",
    "files": [
      {
        "path": "C:/Duhan Projects/teknopark-site/locales/en.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
